import assert from 'nanoassert';
import Poly1305 from './poly1305';
import { crypto_verify_16 } from './crypto_verify';

export const crypto_onetimeauth_BYTES = 16;
export const crypto_onetimeauth_KEYBYTES = 32;

export function crypto_onetimeauth(mac, msg, key) {
  assert(
    mac.byteLength === crypto_onetimeauth_BYTES,
    'mac must be crypto_onetimeauth_BYTES bytes'
  );
  assert(msg.byteLength != null, 'msg must be buffer');
  assert(
    key.byteLength === crypto_onetimeauth_KEYBYTES,
    'key must be crypto_onetimeauth_KEYBYTES bytes'
  );

  var s = new Poly1305(key);
  s.update(msg, 0, msg.byteLength);
  s.finish(mac, 0);
}

export function crypto_onetimeauth_verify(mac, msg, key) {
  assert(
    mac.byteLength === crypto_onetimeauth_BYTES,
    `mac must be ${crypto_onetimeauth_BYTES} bytes`
  );
  assert(msg.byteLength != null, 'msg must be buffer');
  assert(
    key.byteLength === crypto_onetimeauth_KEYBYTES,
    `key must be ${crypto_onetimeauth_KEYBYTES} bytes`
  );

  var tmp = new Uint8Array(16);
  crypto_onetimeauth(tmp, msg, key);
  return crypto_verify_16(mac, 0, tmp, 0);
}
